__turbopack_context__.v({
  "close-button": "o-toast-module__bPpGWq__close-button",
  "headline": "o-toast-module__bPpGWq__headline",
  "section": "o-toast-module__bPpGWq__section",
  "wrapper": "o-toast-module__bPpGWq__wrapper",
});
